import JSZip from "jszip";

export async function loadGlbObjectUrl(file: File) {
  const name = file.name.toLowerCase();
  if (name.endsWith(".glb")) {
    return URL.createObjectURL(file);
  }

  if (!name.endsWith(".zip")) {
    throw new Error("请选择 .glb 或 .zip 文件");
  }

  const zip = await JSZip.loadAsync(file);
  return loadGlbObjectUrlFromZip(zip);
}

export async function loadGlbObjectUrlFromRemote(url: string, objectKey: string) {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`模型下载失败 (${response.status})`);
  }

  const blob = await response.blob();
  const name = objectKey.toLowerCase();
  if (name.endsWith(".glb")) {
    return URL.createObjectURL(new Blob([blob], { type: "model/gltf-binary" }));
  }

  if (!name.endsWith(".zip")) {
    throw new Error("结果文件不是 .glb 或 .zip");
  }

  const zip = await JSZip.loadAsync(blob);
  return loadGlbObjectUrlFromZip(zip);
}

async function loadGlbObjectUrlFromZip(zip: JSZip) {
  const glbEntries = Object.values(zip.files).filter((entry) => {
    return !entry.dir && entry.name.toLowerCase().endsWith(".glb");
  });

  if (glbEntries.length === 0) {
    throw new Error("ZIP 中未找到 .glb 文件");
  }

  const glbBlob = await glbEntries[0].async("blob");
  return URL.createObjectURL(new Blob([glbBlob], { type: "model/gltf-binary" }));
}
